<script setup lang="ts">
import { Money } from '@commercetools/platform-sdk';
import { useVModel } from '@vueuse/core';

import AddToCartButtonGroup from '@/components/base/add-to-cart/AddToCartButtonGroup.vue';
import money from '@/filters/money';

const props = withDefaults(
  defineProps<{
    dataTest?: string;
    disabled?: boolean;
    isLoading?: boolean;
    maximumPiecesPerOrder: number;
    modelValue: number;
    startAutoDelivery?: boolean;
    totalCost: Money;
  }>(),
  {
    modelValue: 1,
  },
);

const emit = defineEmits<{
  submit: [];
  'update:modelValue': [number];
}>();

const quantity = useVModel(props, 'modelValue', emit);
</script>

<template>
  <AddToCartButtonGroup
    v-model:quantity="quantity"
    :data-test="dataTest || 'add-to-auto-delivery'"
    :disabled="disabled"
    :isLoading="isLoading"
    :maximumPiecesPerOrder="maximumPiecesPerOrder"
    theme="blue"
    type="submit"
    @submit="$emit('submit')"
  >
    {{ startAutoDelivery ? 'Start' : 'Add to' }}
    <img class="w-[5.75rem] h-4" alt="Auto-Delivery" src="@/assets/auto-delivery/logo-white.svg" />
    &ndash; {{ money(totalCost) }}
  </AddToCartButtonGroup>
</template>
